import {useCallback} from "react";
import {useApolloClient} from "@apollo/client";
import {useDispatch} from "react-redux";
import {notificationsActions} from "../../store/notificationsSlice";
import {USER_NOTIFICATIONS} from "./queries/UserNotifications";

export function useUnreadSummary() {
    const client = useApolloClient();
    const dispatch = useDispatch();

    const refreshUnreadSummary = useCallback(
        async (profileId) => {
            if (!profileId) {
                dispatch(notificationsActions.resetNotifications());
                return;
            }

            const {data} = await client.query({
                query: USER_NOTIFICATIONS,
                variables: {
                    profileId,
                    isRead: false,
                    page: 1,
                    pageSize: 10,
                },
                fetchPolicy: "network-only",
            });

            const pageData = data?.userNotifications;
            dispatch(
                notificationsActions.setUnreadSummary({
                    unreadCount: pageData?.totalCount ?? 0,
                    topUnread: pageData?.objects ?? [],
                })
            );
        },
        [client, dispatch]
    );

    return {refreshUnreadSummary};
}
